import React from 'react'
import PropTypes from 'prop-types'
import RatingsRiskMorningstarResearch from './RatingsRiskMorningstarResearch.jsx'
import RatingsRiskRiskMeasures from './RatingsRiskRiskMeasures.jsx'
import RatingsRiskRiskReturn from './RatingsRiskRiskReturn.jsx'
import {
  isNull,
  isDisplayNoMessageData,
  isPresented,
  hasLayoutId,
} from '../../Helpers/FundUtility.js'
import DataNotAvailable from '../../Helpers/DataNotAvailable.js'

import './RatingsRisk.css'

function RatingsRisk({ fund }) {
  const hasThreeYrAvg = !isNull(fund.threeYrAvgAnnRetStdDev)
  const hasThreeYrAvgData = !isDisplayNoMessageData(
    fund,
    'threeYrAvgAnnRetStdDev'
  )
  const hasThreeYrAvgPresented = isPresented(fund, 'threeYrAvgAnnRetStdDev')
  const isDisplayNoDataRisk = isDisplayNoMessageData(fund, 'riskDetail')
  const renderRiskMeasures = fund.risk && fund.riskDetail
  // const renderEtfRiskMeasures = (fund.miscellaneousDetails.layoutID == '32' || fund.miscellaneousDetails.layoutID == '34' || fund.miscellaneousDetails.layoutID == '35')
  const renderEtfRiskMeasures = hasLayoutId(fund, [32, 34, 35])
  const renderRiskReturn =
    hasThreeYrAvg && hasThreeYrAvgData && hasThreeYrAvgPresented

  const gridClass = renderRiskMeasures ? 'u-size6of12' : 'u-size12of12'

  if (
    renderRiskMeasures &&
    fund.miscellaneousDetails.activeShareDetails &&
    fund.miscellaneousDetails.activeShareDetails.value
  ) {
    fund.riskDetails.value.push(fund.miscellaneousDetails.activeShareDetails)

    // For Multi-managed funds with Active Share content, get date from portfolioCharsDetails as they use the same DmPortfolio.txt feed
    if (fund.portfolioCharsDetails) {
      fund.risk.effectiveDate = fund.portfolioCharsDetails.effDate
    }
  }

  return (
    <section
      className="section-content u-adel-reset"
      data-section-content="ratings-risk"
      id="ratings-risk"
    >
      <div className="u-sizeConstrained">
        <hr className="Rule Rule--thin Module-divider" role="presentation" />
        <div className="u-paddingVert12gu">
          <h2 className="u-marginBottom6gu" role="heading">
            Ratings &amp; Risk
          </h2>
          <div
            className="Content u-paddingTop0 u-paddingBottom12gu"
            id="morningstar"
          >
            {fund.morningStarRatingDetail ? (
              <RatingsRiskMorningstarResearch
                fund={fund}
                morningStarRatings={fund.morningStarRatingDetail}
              />
            ) : (
              <DataNotAvailable title={'Morningstar Research'} />
            )}
          </div>

          <div className="Grid Grid--withGutter u-sm-flexCol">
            {isPresented(fund, 'threeYrAvgAnnRetStdDev') && (
              <div
                className={`${gridClass} u-sm-marginBottom4gu u-sm-sizeFull`}
                id="risk-return"
              >
                <RatingsRiskRiskReturn
                  risk={fund.risk}
                  threeYrAvgAnnRetStdDev={fund.threeYrAvgAnnRetStdDev}
                />
              </div>
            )}
            {(renderRiskMeasures ||
              renderEtfRiskMeasures ||
              isDisplayNoDataRisk) && (
              <div
                className={`${
                  renderRiskReturn ? 'u-size6of12' : 'u-sizeFull'
                } u-sm-sizeFull`}
                id="risk-three-year"
              >
                {isDisplayNoDataRisk ? (
                  <DataNotAvailable title={'Risk Measures'} />
                ) : (
                  <RatingsRiskRiskMeasures
                    renderRiskReturn={renderRiskReturn}
                    risk={fund.risk}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

RatingsRisk.propTypes = {
  fund: PropTypes.object.isRequired,
}

export default RatingsRisk
